import { render } from "./SavedListMeta.vue?vue&type=template&id=52e34623"
import script from "./SavedListMeta.vue?vue&type=script&lang=js"
export * from "./SavedListMeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__